import { Grid, Typography } from '@mui/material';
import { useLegalProceedingsAttachment } from './hook';
import { LegalProceedingsAttachmentProps } from './props';
import DropZoneField from '../../../../../components/general/fields/dropzoneField/index';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Table } from '../../../../../components/general/table';

export const LegalProceedingsAttachment = (
    props: LegalProceedingsAttachmentProps
) => {
    const {
        handleOnChange,
        columns,
        data: rows,
    } = useLegalProceedingsAttachment(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Archivo adjunto
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <DropZoneField
                    name="attachments"
                    title="Suelte los archivos aquí o haga click para subir (El tamaño máximo no debe superar 30MB)"
                    subtitle={null}
                    subtitle2={null}
                    maxFileSize={30 * 1024 * 1024}
                    onChange={handleOnChange}
                >
                    <CloudUploadIcon fontSize="large" color="warning" />
                </DropZoneField>
            </Grid>
            {rows && rows.length > 0 && (
                <Grid item xs={12}>
                    <Table
                        columns={columns}
                        rows={rows}
                        rowCount={rows.length}
                        pageSizeOptions={[10, 20, 50]}
                        disableRowSelectionOnClick
                    />
                </Grid>
            )}
        </Grid>
    );
};
